import { apiSlice } from '../../../../api/apiSlice';
import { getRemainingTime } from './utils/helper';
import { testSource } from 'config/common';

const source = testSource;

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    newGetAptitudeQuiz: builder.query<any, void>({
      query: () => {
        return {
          url: '/question/newaptitude/random',
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['NewAptitudeQuiz'],
      // NewAptitudeQuiz is from old code
    }),
    newCheckIncompleteAptitude: builder.query<any, void>({
      query: () => {
        return {
          url: '/test/new-aptitude-test/incomplete',
          params: { source },
        };
      },
      transformResponse(res: any) {
        const totalTimeForQuizInMinutes = res.data?.responses.reduce(function (
          acc: number,
          category: any
        ) {
          return acc + category.timeAllowed;
        },
        0);

        const startTime = res.data?.startTime;
        const timeLeftForQuiz = getRemainingTime(
          startTime,
          totalTimeForQuizInMinutes
        );
        if (res.data) {
          res.data.responses[0]['startTime'] = res.data?.startTime;
        }
        // const timeLeftPerCategory = res.data.responses.map((cat:any,index:number)=>{
        //   return  {"category":cat.category,"timeLeft": getRemainingTime(cat.startTime || res.data.startTime,cat.timeAllowed)}
        // });
        return { ...res.data, overallTimeLeft: timeLeftForQuiz };
      },
      providesTags: ['CurrentNewAptitudeQuiz'],
    }),
    newAptitudeTestScore: builder.query<any, void>({
      query: () => {
        return {
          url: '/test/new-aptitude-test/best-attempt',
        };
      },
      transformResponse: (res: any) => {
        return res.data;
      },
      providesTags: ['NewAptitudeQuizScore'],
    }),
    newAptitudeAttempt: builder.query<any, void>({
      query: () => {
        return {
          url: '/test/new-aptitude-test/attempt-status',
        };
      },
      transformResponse: (res: any) => {
        return res.data;
      },
    }),
    newStartAptitudeTest: builder.mutation({
      query(data: any) {
        const newData = { ...data, source };
        const { ...body } = newData;
        return {
          url: `/test/new-aptitude-test/start`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['CurrentNewAptitudeQuiz'],
    }),
    newUpdateResponsesAptitude: builder.mutation({
      query(data: any) {
        const newData = { ...data, source };
        const { ...body } = newData;
        return {
          url: `/test/new-aptitude-test/update-responses`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['CurrentNewAptitudeQuiz'],
    }),
    newFinishAptitudeTest: builder.mutation({
      query() {
        const newData = { source };
        const { ...body } = newData;
        return {
          url: `/test/new-aptitude-test/finish`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [
        'Summary',
        'Onboarding',
        'NewAptitudeQuizScore',
        'CurrentNewAptitudeQuiz',
        'NewAptitudeQuiz',
      ],
    }),
  }),
});

export const {
  useNewGetAptitudeQuizQuery,
  useNewCheckIncompleteAptitudeQuery,
  useNewAptitudeTestScoreQuery,
  useNewAptitudeAttemptQuery,
  useNewStartAptitudeTestMutation,
  useNewUpdateResponsesAptitudeMutation,
  useNewFinishAptitudeTestMutation,
} = extendedApiSlice;
